<!-- Polaris (app): the question of the kit's EditorDrawer and EditSheet (src/product/components/EditorDrawer.vue,
     EditSheet.vue), same markup and classes (translated to Tailwind 3), strings in i18n. Lifted out so the two
     drawers and any drawer built on the Inspector ask with the same words. Goes with useDiscardGuard.js. -->
<script setup>
import { useI18n } from 'vue-i18n';
import { WarningAlt16 } from '@carbon/icons-vue';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { Button } from '../ui/button';

defineProps({
  keepId: { type: String, required: true }, // the id useDiscardGuard focuses
  size: { type: String, default: 'default' }, // the buttons: 'sm' in the wide editor, 'default' in the sheet
});
const emit = defineEmits(['keep', 'discard']);
const { t } = useI18n();
</script>

<template>
  <Alert
    class="border-polaris-warning-foreground/30 bg-polaris-warning text-polaris-warning-foreground"
    data-discard-changes
  >
    <WarningAlt16 />
    <AlertTitle>{{ t('POLARIS.DRAWER.DISCARD_TITLE') }}</AlertTitle>
    <AlertDescription class="text-polaris-warning-foreground">
      <p>{{ t('POLARIS.DRAWER.DISCARD_TEXT') }}</p>
      <div class="mt-3 flex flex-wrap gap-2">
        <Button
          :id="keepId"
          type="button"
          variant="outline"
          :size="size"
          class="text-polaris-foreground"
          @click="emit('keep')"
        >
          {{ t('POLARIS.DRAWER.KEEP_EDITING') }}
        </Button>
        <Button
          type="button"
          variant="destructive"
          :size="size"
          @click="emit('discard')"
        >
          {{ t('POLARIS.DRAWER.DISCARD') }}
        </Button>
      </div>
    </AlertDescription>
  </Alert>
</template>
